<template>
  <v-table
    :count="count"
    :list="list"
    :is-loading="isLoading"
    :push-list="latentStudentTrailListPush"
    :query-list="queryList"
    :is-show-store-select="isAdministrator"
    :is-store-select-clearable="true"
    :is-show-select-card-payment-mode-id="true"
    card-payment-mode-label="收款方式"
    :is-show-quick-time-tab="true"
    :is-show-quick-time-tab-last-thirty-day="true"
    :picker-options="pickerOptions"
  >
    <div slot="summary" class="global-summary-bar">
      筛选范围内：共试课 {{ count }} 人次，试课 {{ totalUnique }} 人，报名 {{ totalSignUp }} 人，报名占比 {{ totalSignUpRate }} %
    </div>

    <v-column-time/>

    <v-column-admin/>

    <el-table-column
      label="课程日期"
      width="160"
      align="center"
    >
      <template v-slot="{ row }">{{ row.start_time | timeToYmd }}</template>
    </el-table-column>

    <v-column-student link-page-id="student_id"/>

    <el-table-column label="手机号" align="center" prop="phone"/>

    <v-column-avatar label="课程老师" avatar-key="teacher_avatar" nickname-key="teacher_names"/>

    <el-table-column label="课程名称" align="center" prop="course_name"/>

    <el-table-column label="试课门店" align="center" prop="store_name"/>

    <el-table-column label="实际付款(元)" align="center">
      <template v-slot="{ row }">
        <span>{{ row.actual_payment | toYuan }}</span>
      </template>
    </el-table-column>

    <el-table-column label="收款方式" align="center">
      <template v-slot="{ row }">
        <span v-if="row.actual_payment">{{ findPaymentModeName(row.card_payment_mode_id) }}</span>
        <span v-else class="info-color">未付款</span>
      </template>
    </el-table-column>

    <el-table-column label="是否报名" width="160" align="center">
      <template v-slot="{ row }">{{ row.card_count ? '是' : '否' }}</template>
    </el-table-column>

    <el-table-column label="报名门店" align="center" prop="card_store_name"/>

    <div slot="append" class="table-count-bar">
      当前页：共试课 {{ pageTrialCount }} 人次，试课 {{ pageUniqueCount }} 人，报名 {{ pageSignUpCount }} 人，报名占比 {{ pageSignUpRate }} %
    </div>

    <template slot="mobile-list">
      <section class="list">
        <template v-if="list.length">
          <div
            v-for="(v, k) in list"
            :key="`card-list-${k}-${v.id}`"
            class="list-item primary-background-light"
          >
            <div class="list-item-detail">
              <span>操作者</span>
              <v-avatar-nickname
                :value="v.administrator_avatar"
                :nickname="v.administrator_nickname"
                :is-center="true"
                :avatar-size="50"
                width="30vw"
              />
            </div>

            <div class="list-item-detail">
              <span>试课学员</span>
              <v-avatar-nickname
                :value="v.selfie"
                :nickname="v.student_name"
                :is-center="true"
                :link-page-name="RouteConfig.studentDetail.name"
                :link-page-id="v.student_id"
                :avatar-size="50"
                width="30vw"
              />
            </div>

            <div class="list-item-detail">
              <span>课程老师</span>
              <v-avatar-nickname
                :value="v.teacher_avatar"
                :nickname="v.teacher_names"
                :is-center="true"
                :link-page-name="RouteConfig.teacherDetail.name"
                :link-page-id="v.teacher_id"
                :avatar-size="50"
                width="30vw"
              />
            </div>

            <div class="list-item-detail">
              <span>添加时间</span>
              <span>{{ v.add_time | timeToYmdHi }}</span>
            </div>

            <div class="list-item-detail">
              <span>课程日期</span>
              <span>{{ v.start_time | timeToYmd }}</span>
            </div>

            <div class="list-item-detail">
              <span>手机号</span>
              <span>{{ v.store_name || '' }}</span>
            </div>

            <div class="list-item-detail">
              <span>课程名称</span>
              <router-link v-if="v.course_id" class="primary-color" :to="RouteConfig.courseManage.to(v.course_id)">
                {{ v.course_name }}
              </router-link>
            </div>

            <div class="list-item-detail">
              <span>试课门店</span>
              <span>{{ v.store_name || '' }}</span>
            </div>

            <div class="list-item-detail">
              <span>实际付款</span>
              <span>{{ v.actual_payment | toYuan }} 元</span>
            </div>

            <div class="list-item-detail">
              <span>收款方式</span>
              <span v-if="v.actual_payment">{{ findPaymentModeName(v.card_payment_mode_id) }}</span>
              <span v-else class="info-color">未付款</span>
            </div>

            <div class="list-item-detail">
              <span>是否报名</span>
              <span>{{ v.card_count ? '是' : '否' }}</span>
            </div>

            <div class="list-item-detail">
              <span>报名门店</span>
              <span>{{ v.card_store_name || '' }}</span>
            </div>

            <div class="list-item-detail"></div>
          </div>

          <div class="list-item list-count-box primary-background-light">
            <div class="list-item-detail">
              <span>当前页共试课</span>
              <span>{{ pageTrialCount }} 人次</span>
            </div>

            <div class="list-item-detail">
              <span>报名</span>
              <span>{{ pageSignUpCount }} 人</span>
            </div>

            <div class="list-item-detail">
              <span>报名占比</span>
              <span>{{ pageSignUpRate }} %</span>
            </div>
          </div>
        </template>

        <v-empty :is-loading="isLoading" :length="list.length"/>
      </section>
    </template>
  </v-table>
</template>

<script>
import RouteConfig from '@/router/config';
import { mapGetters } from 'vuex';
import { index } from '@/api/trial-payment';
import { findPaymentModeName } from '@/enums/paymentModes';
import { checkYmdIsBetweenSetUpAndToday } from '@/utils/validate';
import { getLegalQueryList } from '@/utils/formats';
import { getDay } from '@/utils/formats';
import { dividedBy, multipliedBy, decimalPlaces } from "@/filters";

export default {
  name: RouteConfig.latentStudentTrailList.name,
  data: () => ({
    RouteConfig,
    latentStudentTrailListPush: RouteConfig.latentStudentTrailList.push,
    isLoading: false,
    isDeleting: false,
    count: 0,
    totalUnique: 0,
    totalSignUp: 0,
    totalSignUpRate: 0,
    pageTrialCount: 0,
    pageUniqueCount: 0,
    pageSignUpCount: 0,
    pageSignUpRate: 0,
    timeLimit: [],
    list: [],
    reports: [],
    stores: [],
    queryList: {
      store_id: '',
      card_payment_mode_id: '',
      start_date: '',
      end_date: '',
      is_asc: 0,
      page: 1,
      size: 8,
    },
    pickerOptions: {
      disabledDate(time) {
        return time.getTime() >= Date.now();
      },
    },
  }),
  computed: {
    ...mapGetters([
      'isMobile',
      'isAdministrator',
      'isManager',
      'isReceptionist',
      'userStoreId',
    ]),
  },
  watch: {
    '$route'(to) {
      this.load(to);
    },
  },
  beforeMount() {
    this.load();
  },
  methods: {
    findPaymentModeName,
    refresh() {
      RouteConfig.latentStudentTrailList.push(this.queryList);
    },
    handleStoreChange() {
      this.queryList.page = 1;
      this.refresh();
    },
    handlePageChange({ page, size }) {
      this.queryList.page = page;
      this.queryList.size = size;
      this.refresh();
    },
    handleTimeLimitChange(times) {
      if (!times || !times.length) times = ['', ''];

      this.timeLimit = times;
      const [ start_date, end_date ] = times;

      Object.assign(this.queryList, {
        start_date,
        end_date,
        page: 1,
      });
      this.refresh();
    },
    async load(route = this.$route, next) {
      const { queryList } = this;
      const { query } = route;
      getLegalQueryList(queryList, query);

      const startDateIsValid = checkYmdIsBetweenSetUpAndToday(query.start_date);
      const endDateIsValid = checkYmdIsBetweenSetUpAndToday(query.end_date);

      if (startDateIsValid && endDateIsValid) {
        queryList.start_date = query.start_date;
        queryList.end_date = query.end_date;
      } else {
        // 首次进入（地址栏无任何参数）默认展示今天；用户点击“全部”时会带上其他筛选参数、但不带日期，
        // 此时必须保持空日期区间（全部），否则会被重置回今天并导致“全部”需点击两次
        const today = Object.keys(query).length ? '' : getDay();
        queryList.start_date = today;
        queryList.end_date = today;
      }

      this.isLoading = true;
      const { isError, data } = await index(this.queryList);
      this.isLoading = false;

      if (next) next();
      if (isError) return;

      this.list = data.list || [];

      // 筛选范围内全局统计
      this.count = data.count || 0;
      this.totalUnique = data.count_unique || 0;
      this.totalSignUp = data.sign_up_unique || 0;
      this.totalSignUpRate = decimalPlaces(multipliedBy(dividedBy(this.totalSignUp, this.totalUnique), 100), 2);

      // 当前页统计
      this.pageTrialCount = this.list.length;
      this.pageUniqueCount = new Set(this.list.map(v => v.student_id)).size;
      this.pageSignUpCount = new Set(this.list.filter(v => v.card_count > 0).map(v => v.student_id)).size;
      this.pageSignUpRate = decimalPlaces(multipliedBy(dividedBy(this.pageSignUpCount, this.pageUniqueCount), 100), 2);
    },
  },
};
</script>

<style scoped>
.global-summary-bar {
  height: 49px;
  display: flex;
  align-items: center;
  padding-left: 10px;
  background: #ecf5ff;
  color: #409eff;
  font-size: 14px;
  border-bottom: 1px solid #d9ecff;
}
</style>
